const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <path
            d="M50.164 29.598a1.755 1.755 0 01-2.477 0L29.069 11.016v38.913a1.75 1.75 0 01-1.753 1.749 1.75 1.75 0 01-1.752-1.75V11.017L6.946 29.598a1.755 1.755 0 01-2.477 0 1.746 1.746 0 010-2.473L26.077 5.558a1.755 1.755 0 012.478 0l21.61 21.567c.684.683.684 1.79 0 2.473z"
            fill="currentColor" fill-rule="nonzero" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=arrow-up-long.es.DZ_1rqkL.js.map
